// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2sL4j","header":"PatientQuestionnaire_header__deFwj","info":"PatientQuestionnaire_info__y4m-6"};